import { render, staticRenderFns } from "./EspecialidadesVinculadas.vue?vue&type=template&id=e5314156&"
import script from "./EspecialidadesVinculadas.vue?vue&type=script&lang=js&"
export * from "./EspecialidadesVinculadas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports